<template>
  <v-app>
    <v-main>
      <router-view/>
    </v-main>
    <Navigation/>
    <Toast ref="ErrorUser"/>
    <Toast ref="ErrorRegister"/>
    <Toast ref="ErrorLogin"/>
    <Toast ref="Toast"/>
    <CookieConsent/>
  </v-app>
</template>

<script>
import Navigation from '@/components/Navigation';
import Toast from '@/components/modal/Toast';
import CookieConsent from '@/components/legal/CookieConsent';
import {mapGetters} from "vuex";

export default {
  name: 'App',
  components: {
    Navigation,
    Toast,
    CookieConsent,
  },
  computed: {
    ...mapGetters([
      'jwt',
      'errorUser',
      'user'
    ])
  },
  methods: {
    showError(toast, value) {
      if (toast && value) {
        this.$refs[toast].show({
          color: 'error',
          icon: 'fa-solid fa-circle-xmark',
          title: 'Fehler',
          text: value,
          timeout: 99999
        });
      }
    }
  },
  created() {
    this.$store.dispatch('getCompany');
    this.$store.dispatch('getFirmas');
    this.$store.dispatch('getBranchen');

    const jwt = localStorage.getItem('jwt');
    if (jwt) {
      this.$store.dispatch('login', {jwt: jwt});
    }
  },
  watch: {
    errorUser(value) {
      this.showError('ErrorUser', value);
    }
  }
}
</script>

<style lang="scss">
@import "./src/styles/main.scss";
</style>
